import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxLembarRalat extends Component {
  render() {
    return (
      <Inbox type='TNDE_LEMBAR_RALAT'/>
    );
  }
}
